export default __webpack_public_path__ + "91767b6436f45e01b058ec27dc6f3d0f.svg";